import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import OrganizationService from '../services/organization.service';
import { displayAlert } from './feedbackSlice';
import { manageError } from '../utils/helpers';

export const getOrganization = createAsyncThunk(
  'organization/get',
  async (thunkAPI) => {
    try {
      const data = await OrganizationService.getOrganization();
      return { organization: data.data };
    } catch (error) {
      const message = manageError(error);
      thunkAPI.dispatch(displayAlert(message, 'error'));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const updateOrganization = createAsyncThunk(
  'organization/update',
  async ({ id, ...champs }, thunkAPI) => {
    try {
      const data = await OrganizationService.updateOrganization(id, champs);
      return { organization: data.data };
    } catch (error) {
      const message = manageError(error);
      thunkAPI.dispatch(displayAlert(message, 'error'));
      return thunkAPI.rejectWithValue({ message });
    }
  },
);

export const createOrganization = createAsyncThunk(
  'organization/post',
  async (organizationData, thunkAPI) => {
    try {
      const data = await OrganizationService.createOrganization(organizationData);
      return { organization: data.data };
    } catch (error) {
      const message = manageError(error);
      thunkAPI.dispatch(displayAlert(message, 'error'));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const getSubscription = createAsyncThunk(
  'subscription/get',
  async (thunkAPI) => {
    try {
      const data = await OrganizationService.getSubscription();
      return { subscription: data.data };
    } catch (error) {
      const message = manageError(error);
      thunkAPI.dispatch(displayAlert(message, 'error'));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const organizationSlice = createSlice({
  name: 'organization',
  initialState: {
    organization: {},
    subscription: { plan: null, interval: null, active: false },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOrganization.fulfilled, (state, action) => {
      state.organization = action.payload.organization;
    });
    builder.addCase(getOrganization.rejected, (state, action) => {
      state.organization = {};
    });
    builder.addCase(updateOrganization.fulfilled, (state, action) => {
      // L'organisation entière est remplacée par ce que l'API rend : c'est
      // elle qui fait foi, pas ce que le formulaire croyait envoyer.
      state.organization = action.payload.organization;
    });
    builder.addCase(createOrganization.fulfilled, (state, action) => {
      state.organization = action.payload.organization;
    });
    builder.addCase(getSubscription.fulfilled, (state, action) => {
      state.subscription = action.payload.subscription;
    });
    builder.addCase(getSubscription.rejected, (state, action) => {
      state.subscription = {};
    });
  },
});

export default organizationSlice.reducer;
